export default {"src":"/_next/static/media/shape.a3fe0b08.svg","height":6,"width":46,"blurWidth":0,"blurHeight":0};